import React from "react"
import {Chip} from "@mui/material"
import {colors} from "@indebted/theme"

function SystemOfRecordChip({systemOfRecord}: {systemOfRecord: string}) {
	switch (systemOfRecord) {
		case "Latitude":
			return (
				<Chip
					label="Latitude"
					size="medium"
					sx={{
						backgroundColor: colors.chipPrimaryBackground,
						color: "#d32f2f",
						border: "none",
						marginLeft: 2,
					}}
				/>
			)
		case "Collect":
			return null
		default:
			return null
	}
}

export {SystemOfRecordChip}
